import { apiClient } from '@/api/client';
import type { ApiResponse } from '@/types/api';
import type { SocietyNavigationPreferenceData } from '@/permissions/menuConfig';

export interface SocietyNavigationPreferenceResponse extends SocietyNavigationPreferenceData {
  _id?: string;
  tenantId?: string;
  updatedAt?: string;
  isDefault?: boolean;
}

export const navigationPreferenceService = {
  async getPreferences(societyId?: string): Promise<SocietyNavigationPreferenceResponse> {
    const url = societyId
      ? `/societies/${societyId}/navigation-preferences`
      : '/societies/navigation-preferences';
    const { data } = await apiClient.get<ApiResponse<SocietyNavigationPreferenceResponse>>(url);
    return data.data;
  },

  async updatePreferences(
    payload: {
      version?: number;
      mainNavigation: Array<{
        menuId: string;
        order: number;
        visible?: boolean;
        children?: Array<{
          menuId: string;
          order: number;
          visible?: boolean;
        }>;
      }>;
      secondaryNavigation?: Array<{
        menuId: string;
        order: number;
        visible?: boolean;
      }>;
    },
    societyId?: string,
  ): Promise<SocietyNavigationPreferenceResponse> {
    const url = societyId
      ? `/societies/${societyId}/navigation-preferences`
      : '/societies/navigation-preferences';
    const { data } = await apiClient.put<ApiResponse<SocietyNavigationPreferenceResponse>>(
      url,
      payload,
    );
    return data.data;
  },

  async resetPreferences(societyId?: string): Promise<SocietyNavigationPreferenceResponse> {
    const url = societyId
      ? `/societies/${societyId}/navigation-preferences/reset`
      : '/societies/navigation-preferences/reset';
    const { data } = await apiClient.post<ApiResponse<SocietyNavigationPreferenceResponse>>(url);
    return data.data;
  },
};
